import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-4">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-5" />

      {/* Modal Content */}
      <div className="relative w-full max-w-2xl max-h-[80vh] bg-slate-900 border border-slate-700 rounded-2xl shadow-2xl flex flex-col overflow-hidden" data-id="element-6">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-800" data-id="element-7">
          <h2 className="text-lg font-serif font-semibold text-slate-100" data-id="element-8">
            {title}
          </h2>
          <button onClick={onClose} className="p-1.5 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800 transition-colors" aria-label="Cerrar" data-id="element-9">
            <X className="h-5 w-5" data-id="element-10" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-6 overflow-y-auto text-sm text-slate-300 leading-relaxed space-y-4" data-id="element-11">
          {children}
        </div>
      </div>
    </div>;
}